export default {"src":"/_next/static/media/NO.6b98e0dc.svg","height":355,"width":512,"blurWidth":0,"blurHeight":0};